import TeamTableContainer from './TeamTableContainer';

export default TeamTableContainer;
